import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Shared "What this includes" list + Show all / Show less toggle for package grid cards.
 */
@Component({
  selector: 'app-package-grid-card-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './package-grid-card-features.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./package-grid-card-features.component.scss'],
})
export class PackageGridCardFeaturesComponent {
  @Input() features: string[] = [];
  @Input() hasHiddenFeatures = false;
  @Input() toggleLabel = 'Show all';
  @Output() toggle = new EventEmitter<void>();

  trackByIndex(index: number): number {
    return index;
  }
}
